<template>
  <div :class="$style['pt-integral-exchange-detail']">
    <pt-page-title title="订单详情"></pt-page-title>
    <div v-if="router_name=='integral-exchange-detail'">
    <pt-sub-title title="订单状态"></pt-sub-title>
    <order-states :orderDetail="integralDetail" :steps="orderStatesArray"></order-states>
    </div>

    <!-- <el-steps :active="1" align-center>
      <el-step title="已下单" :description="description"></el-step>
      <el-step title="已付款" description=""></el-step>
      <el-step title="已完成" description=""></el-step>
    </el-steps> -->
    <pt-sub-title title="订单信息"></pt-sub-title>
    <wt-grid :col="2" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <p><span :class="$style['order-info__name']">订单号：</span>{{integralDetail.orderNumber}}</p>
        <p><span
            :class="$style['order-info__name']">商品名称：</span>{{integralDetail.goods && integralDetail.goods[0] && integralDetail.goods[0].name}}
        </p>
        <p><span
            :class="$style['order-info__name']">商品数量：</span>{{integralDetail.placementDetails&& integralDetail.placementDetails.goods && integralDetail.placementDetails.goods.number}}
        </p>
        <p><span
            :class="$style['order-info__name']">消费积分：</span>{{integralDetail.paymentSummary && integralDetail.paymentSummary.total}}
        </p>
        <p><span :class="$style['order-info__name']">下单时间：</span>{{formatDateObject(integralDetail.createdDate)}}</p>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <p><span
            :class="$style['order-info__name']">用户：</span>{{integralDetail.placeUserRoleInformation && integralDetail.placeUserRoleInformation.fullName}}
        </p>
        <p><span
            :class="$style['order-info__name']">联系方式：</span>{{integralDetail.placeUserRoleInformation && integralDetail.placeUserRoleInformation.mobile}}
        </p>
      </wt-box>
    </wt-grid>
    <div :class="$style['item-line']"></div>
    <wt-grid :col="2" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <p><span
            :class="$style['order-info__name']">收件地址：</span>{{(integralDetail.shippingAddress&&integralDetail.shippingAddress.provinceName?integralDetail.shippingAddress.provinceName:'')+(integralDetail.shippingAddress&&integralDetail.shippingAddress.cityName?integralDetail.shippingAddress.cityName:'')+
                        (integralDetail.shippingAddress && integralDetail.shippingAddress.districtName?integralDetail.shippingAddress.districtName:'')+(integralDetail.shippingAddress && integralDetail.shippingAddress.postAddress?integralDetail.shippingAddress.postAddress:'')}}
        </p>
        <p><span
            :class="$style['order-info__name']">收件人：</span>{{integralDetail.shippingAddress?integralDetail.shippingAddress.contactName:'--'}}
        </p>
        <p><span
            :class="$style['order-info__name']">收件人电话：</span>{{integralDetail.shippingAddress?integralDetail.shippingAddress.phone:'--'}}
        </p>
      </wt-box>
    </wt-grid>
    <after-sales-message :goodsData="integralDetail.goods&&integralDetail.goods[0]" title="订单规则" from="order"
      :tdMaxWidth="tdMaxWidth"></after-sales-message>
    <template v-if="router_name=='integral-refund-detail'">
      <pt-sub-title title="申请退还积分信息"></pt-sub-title>
      <apply-refund-message v-if="isShowRefundDetail && !isRefundAppleAgain" :order-detail="integralDetail"
        :refundment-details="refundmentDetails" @refundAppleAgain="refundAppleAgain" @refreshDetail="refreshDetail" :title="false">
      </apply-refund-message>
      <apply-refund-form :isApplyAgain="isRefundAppleAgain" v-else :order-detail="integralDetail" @cancel="refundCancel"
        @getRefundmentReason="getRefundmentReason" :refundReasonList="refundReasonList"
        :refundReasonLoading="refundReasonLoading" :againApplyDetail="refundmentApply" :title="false"></apply-refund-form>
    </template>
    <template v-else>
      <template v-if="isRefundPage">
        <pt-sub-title title="申请退还积分信息"></pt-sub-title>
        <template v-if="isShowRefundDetail && !isRefundAppleAgain">
          <apply-refund-message @refundAppleAgain="refundAppleAgain" :order-detail="integralDetail"
            :refundment-details="refundmentDetails" @refreshDetail="refreshDetail" :title="false"></apply-refund-message>
        </template>
        <template v-else>
          <apply-refund-form :order-detail="integralDetail" @getRefundmentReason="getRefundmentReason"
            :refundReasonList="refundReasonList" :refundReasonLoading="refundReasonLoading"
            :againApplyDetail="refundmentApply" :title="false"></apply-refund-form>
        </template>
      </template>
    </template>
    <!-- <div :class="$style.button">
      <el-button type="primary" @click="goDelivery()">订单发货</el-button>
      <el-button type="primary" @click="goCancel()">取消订单</el-button>
    </div> -->

  </div>
</template>

<script>
import orderStates from '../../../goods-order/pt-order-detail/order-states'
import applyRefundMessage from '../../../goods-order/pt-order-detail/apply-refund-message'
import applyRefundForm from '../../../goods-order/pt-order-detail/apply-refund-form'
import afterSalesMessage from '../../../mall-manage/pt-goods-manage/pt-goods-detail/after-sales-message'
import {
  formatDateObject
} from '@/utils/formUtils'
  // 组件class前缀
const prefixCls = 'pt-integral-exchange-detail'

export default {
  name: 'pt-integral-exchange-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 是否是退款页面
    isRefundPage () {
      return this.operation === 'refund'
    },
    paymentDetails () {
      return (this.integralDetail && this.integralDetail.paymentDetails) || {}
    },
    refundmentDetails () {
      return (this.integralDetail && this.integralDetail.refundmentDetails) || {}
    },
    // 是否显示退款信息（为true时，显示退款详情，false时，显示退款表单）
    isShowRefundDetail () {
      return this.paymentDetails && this.refundmentDetails.status
    },
    // 退款的申请信息
    refundmentApply () {
      return this.refundmentDetails.apply || {}
    }
  },
  components: {
    orderStates,
    applyRefundMessage,
    afterSalesMessage,
    applyRefundForm
  },
  props: {
    orderStatesArray: {
      type: Array,
      default: function () {
        return []
      }
    },
    integralDetail: {
      type: Object,
      default: () => {}
    },
    IntegralGoods: {
      type: Object,
      default: () => {}
    },
    operation: {
      type: String,
      default: ''
    },
    refundReasonList: {
      type: Array,
      default: function () {
        return []
      }
    },
    refundReasonLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    orderDetail: {
      handler: function (val) {
        // this.order_detail = val
        this.isRefundAppleAgain = false
      },
      deep: true
    }

  },
  data () {
    return {
      description: '2018-12-20 14:09:26',
      tdMaxWidth: '100',
      // 是否是再次申请
      isRefundAppleAgain: false,
      router_name: ''
    }
  },
  methods: {
    getRefundmentReason () {
      this.$emit('getRefundmentReason')
    },
    refreshDetail () {
      this.$emit('refreshDetail')
    },
    refundCancel () {
      this.isRefundAppleAgain = false
    },
    refundAppleAgain () {
      this.isRefundAppleAgain = true
    },
    formatDateObject,
    goDelivery () {

    },
    goCancel () {

    }
  },
  created () {
    this.router_name = this.$route.name
  }
}
</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-integral-exchange-detail {
    :global {
      .el-step__head.is-process {
        color: #c0c4cc;
        border-color: #c0c4cc
      }

      .el-step__title.is-process {
        color: #c0c4cc;
      }

      .el-step__description.is-process {
        color: #c0c4cc;
      }

      .el-step__icon.is-text {
        width: 50px;
        height: 50px;
        font-size: 25px;
      }

      .el-step__icon-inner {
        font-weight: 100;
      }

      .el-step.is-horizontal .el-step__line {
        top: 25px
      }

      .is-finish {
        .el-step__icon.is-text {
          background-color: #edbe81;
          color: #fff;
        }
      }
    }
  }

  .order-info__box {
    padding: 10px 20px;
  }

  .order-info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    &__name {
      color: #EDBE81;
      width: 1rem;
      text-align: end;
      display: inline-block;
    }
  }

  .item-line {
    border-bottom: 1px solid #C6CAD4;
    margin: .1rem .2rem;
    width: 100%;
  }

  .button {
    margin-top: .3rem;
  }
</style>
